<template>
    <div class="popup-container" v-if="isShowCategories">
        <div class="popup-overlay" v-bind:class="{'modal-overlay-visible': isShowCategories}"></div>
        <div class="popup popup-category" v-bind:class="{'modal-in': modeIn, 'modal-out': !modeIn}">
            <div class="popup-wrapper">
                <div class="popup-close" @click="close">
                    <img src="https://resource.rcclchina.com.cn/tui2/user_center/popup-close.png" class="">
                </div>
                <div class="popup-content">
                    <div class="popup-caetgory-list">
                        <div class="suggestion-category-item" v-for="(item) in categoryList" :key="item.id" @click="selectCategory(item)">
                            {{item.name}}
                            <span><i class="f7-icons" v-bind:class="{cur: selectId === item.id}">check</i></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {delayDev} from '@/utilities/tools'
    export default {
        name: 'SuggestionCategory',
        components: {},
        props: {
            isShow: {
                type: Boolean,
                default: false
            },
            categoryList: {
                type: Array,
                default: () => {
                    return []
                }
            }
        },
        data: () => {
            return {
                selectId: '',
                isShowCategories: false,
                modeIn: false
            }
        },
        watch: {
            'isShow' (newVal) {
                if (newVal) {
                    this.isShowCategories = newVal
                    delayDev(10, () => {
                        this.modeIn = newVal
                    })
                } else {
                    this.modeIn = newVal
                    delayDev(400, () => {
                        this.isShowCategories = newVal
                    })
                }
            }
        },
        methods: {
            close () {
                this.$emit('on-close')
            },
            selectCategory (item) {
                this.selectId = item.id
                this.$emit('on-select', item)
            }
        }
    }
</script>

<style scoped>
    .popup-container{
        position: fixed;
        left: 0;
        top: 0;
        z-index: 99999;
        width: 100%;
        height: 100%;
    }
    .popup-overlay{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.4);
        z-index: 100;
        visibility: hidden;
        opacity: 0;
        -webkit-transition-duration: 400ms;
        transition-duration: 400ms;
    }
    .modal-overlay-visible{
        visibility: visible;
        opacity: 1;
    }

    .popup-category{
        display: block;
        height: 85%;
        top: auto;
        bottom: 0;
        border-top: 5px solid #FEBC10;
    }

    .popup-wrapper {
        position: relative;
        width: 100%;
        height: 100%;
    }

    .popup-close {
        position: absolute;
        width: 30px;
        top: -2px;
        right: -2px;
        z-index: 10;
    }

    .popup-close img{
        width: 100%;
    }

    .popup-content {
        position: relative;
        width: 100%;
        height: 100%;
        overflow: scroll;
        padding: 0px 20px;

    }

    .popup-content .suggestion-category-item {
        border-bottom: 1px solid rgba(229, 229, 229, 0.7);
        height: 75px;
        line-height: 75px;
        font-size: 14px;
        color: #333;
    }

    .popup-content .suggestion-category-item .f7-icons {
        color: #2560D4;
        margin-left: 20px;
        font-size: 18px;
        display: none;
    }
    .popup-content .suggestion-category-item .cur{
        display: inline;
    }
</style>
